export const SmartLinksForm = ({
  formData,
  handleChange,
  handleSubmit,
  loading,
  createdLink,
  isotipoImg
}) => {
  return (
    <>
      <form onSubmit={handleSubmit} className="space-y-4 links-form">

  {/*  Datos del comercio */}
  <div className="comerce-section">
    <p className="fw-bold h3">Datos del comercio</p>
    <div className="f-inputs">
      <input
        type="text"
        name="merchantName"
        placeholder="Nombre del comercio"
        value={formData.merchantName}
        onChange={handleChange}
        required
        className="border p-2 rounded w-full inputs"
      />

      <input  
        type="email"
        name="email"
        placeholder="Correo de contacto"
        value={formData.email}
        onChange={handleChange}
        required
        className="border p-2 rounded w-full inputs"
      />

      <input
        type="tel"
        name="phoneNumber"
        placeholder="Numero de contacto"
        value={formData.phoneNumber}
        onChange={handleChange}
        required
        className="border p-2 rounded w-full inputs"
      />
    </div>
  </div>

  {/* Detalles del producto */}
  <div className="product-info">
    <p className="fw-bold h3">Detalles del producto</p>

    <input
      type="text"
      name="description"
      placeholder="Descripción del producto"
      value={formData.description}
      onChange={handleChange}
      required
      className="border p-2 rounded w-full inputs"
    />

    <input
      type="text"
      name="productName"
      placeholder="Nombre del Producto"
      value={formData.productName}
      onChange={handleChange}
      required
      className="border p-2 rounded w-full inputs"
    />

    {formData.paymentType !== "open" && (
      <input
        type="number"
        name="price"
        min={50.0}
        placeholder="Precio (MXN)"
        step="0.01"
        max={200000}
        value={formData.price}
        onChange={handleChange}
        required
        className="border p-2 rounded w-full inputs"
      />
    )}
  </div>

  {/* Configuración del pago */}
  <div className="config-paymenth">
    <p className="fw-bold h3">Tipos de pagos</p>

    <select
      name="paymentType"
      value={formData.paymentType}
      onChange={handleChange}
      className="border p-2 rounded w-full inputs"
    >
      <option value="unique">Pago Único</option>
      <option value="open">Monto Abierto</option>
    </select>

    {formData.paymentType === "open" && (
      <>
        <input
          type="number"
          min={50.0}
          name="minAmount"
          placeholder="Monto mínimo"
          value={formData.minAmount}
          onChange={handleChange}
          required
          className="border p-2 rounded w-full inputs"
        />

        <input
          type="number"
          name="maxAmount"
          min={50.0}
          placeholder="Monto máximo"
          value={formData.maxAmount}
          onChange={handleChange}
          required
          className="border p-2 rounded w-full inputs"
        />

        <input
          type="number"
          name="defaultAmount"
          placeholder="Monto por defecto (opcional)"
          value={formData.defaultAmount}
          onChange={handleChange}
          className="border p-2 rounded w-full inputs"
        />
      </>
    )}

    <select
      name="limitType"
      value={formData.limitType}
      onChange={handleChange}
      className="border p-2 rounded w-full inputs"
    >
      <option value="0">Sin Límite de usos</option>
      <option value="1">Con Límite de usos</option>
    </select>

    {formData.limitType === "1" && (
      <input
        type="number"
        name="executionLimit"
        value={formData.executionLimit}
        onChange={handleChange}
        className="border p-2 rounded w-full inputs"
        placeholder="Número de usos"
      />
    )}
  </div>

  <button
    type="submit"
    disabled={loading}
    className="bg-blue-600 text-white px-4 py-2 rounded send-buttons"
  >
    {loading ? "Creando SmartLink..." : "Crear Link de cobro"}
  </button>

</form>

{/* Link generado */}
{createdLink && (
  <div className="link-success-container">
    <h3>¡Link creado con éxito!</h3>
    <div className="link-display">
      <a
        href={createdLink}
        target="_blank"
        className="smartlink-view"
        rel="noopener noreferrer"
      >
        {createdLink}
      </a>
    </div>
  </div>
)}

{/* Modal de carga */}
{loading && (
  <div className="loading-overlay">
    <div className="loading-modal">
      <img src={isotipoImg} alt="Peiix" className="loadingimg" />
      <p>Generando SmartLink, espera...</p>
      <div className="spinner"></div>
    </div>
  </div>
)}
    </>
  );
};
